import Vue from 'vue';
import { Table, TableColumn } from 'element-ui';
Vue.use(Table).use(TableColumn);

delete Table._Ctor;
const { bindEvents } = Table.methods;
Object.assign(Table.methods, {
  bindEvents() {
    bindEvents.call(this);
    this.bodyWrapper.addEventListener(
      'mousewheel',
      this.handleBodyMousewheel
    );     
  },
  handleBodyMousewheel(event) {
    const { fixedWrapper, rightFixedWrapper } = this.$refs;
    if (fixedWrapper) {
      const fixedBodyWrapper = fixedWrapper.querySelector(
        '.el-table__fixed-body-wrapper'
      );
      if (fixedBodyWrapper) {
        event.preventDefault();
          fixedBodyWrapper.scrollBy({
            left: event.deltaX,
            top: event.deltaY,
          });
          this.$refs.bodyWrapper.scrollBy({
            left: event.deltaX,
            top: event.deltaY,
            });
        }
      }
      if (rightFixedWrapper) {
        const fixedBodyWrapper = rightFixedWrapper.querySelector(
          '.el-table__fixed-body-wrapper'
        );
        if (fixedBodyWrapper) {
          event.preventDefault();
          fixedBodyWrapper.scrollBy({
            right: event.deltaX,
            top: event.deltaY,
          });
          this.$refs.bodyWrapper.scrollBy({
            right: event.deltaX,
            top: event.deltaY,
          });
        }
      }
    },
});
Vue.component(Table.name, Table);